module.exports = __webpack_public_path__ + "static/media/tamandua-bandeira.bf2e2c5e.webp";